import React, { Component, useState, useEffect } from "react";

import AgGridReactEx from "@app/components/AgGridReactEx";

import Modal from "react-bootstrap/Modal";

import crypto from "crypto";

import * as Constant from "../../../Constant.js";

import axios from "@app/lib/axios";

const easyFilter = [
    {
        displayKey: "포함",
        displayName: "키워드 포함",
        test: function (filterValue, cellValue) {
            if (cellValue == null) return false;
            return cellValue.indexOf(filterValue) >= 0;
        },
    },
    {
        displayKey: "일치",
        displayName: "키워드 일치",
        test: function (filterValue, cellValue) {
            return filterValue == cellValue;
        },
    },
];

class Users extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            insertModal: false,
            list: [],
            groupList: [],
            listColumn: [
                {
				    headerName: "No",
				    field: "id",
				    sortable: true,
				    minWidth : 40,
				    cellClass: "text-center",
				    filter: "agTextColumnFilter",
				    filterParams: {
		        		filterOptions: easyFilter
		        	}
				},
                {
                    headerName: "권한",
                    sortable: true,
                    sort: "desc",
                    field: "group_desc",
                    sortable: true,
                    minWidth: 105,
                    cellClass: "text-center",
                    filter: "agTextColumnFilter",
                    cellRenderer: function (params) {
                        if(params.value) return params.value
                        else return ""
                    },
                },
                {
                    headerName: "이름",
                    field: "name",
                    sortable: true,
                    minWidth: 105,
                    cellClass: "text-center",
                    filter: "agTextColumnFilter",
                    filterParams: {
                        filterOptions: easyFilter,
                    },
                },
                {
                    headerName: "ID",
                    field: "user_id",
                    minWidth: 105,
                    cellClass: "text-center",
                    filter: "agTextColumnFilter",
                    filterParams: {
                        filterOptions: easyFilter,
                    },
                },
                {
                    headerName: "사용여부",
                    field: "is_active",
                    width: 110,
                    minWidth: 100,
                    cellClass: "text-center",
                    cellRenderer: function (params) {
                        if(params.value) return "사용"
                        else return "미사용"
                    ;
                    },
                },
                {
                    headerName: "수정일",
                    field: "update_date",
                    width: 110,
                    minWidth: 100,
                    cellClass: "text-center"
                    
                },
                {
                    headerName: "비밀번호",
                    field: "id",
                    width: 110,
                    minWidth: 100,
                    cellClass: "text-center",
                    cellRenderer: function (params) {
                        return `
                        <div class='btn-group'>
                            <button class='btn pl-2 pr-2 pt-1 pb-1 btn-primary' onClick="initPass(${params.value})">초기화</button>
                        </div>
                    `;
                    },
                },
                {
                    headerName: "관리",
                    field: "id",
                    width: 110,
                    minWidth: 100,
                    cellClass: "text-center",
                    cellRenderer: function (params) {
                        return `
                        <div class='btn-group'>
                            <button class='btn pl-2 pr-2 pt-1 pb-1 btn-primary' onClick="openUserInfoModal(${params.value})">수정</button>
                            <button class='btn pl-2 pr-2 pt-1 pb-1 btn-danger' onClick="deleteUser(${params.value})">삭제</button>
                        </div>
                    `;
                    },
                }
               
            ],
        };
        window.initPass = this.initPass;
        window.onChangeGroup = this.onChangeGroup;
        window.openUserInfoModal = this.openUserInfoModal;
        window.deleteUser = this.deleteUser;
    }

    componentDidMount() {
        this.getUserList();
        this.getGroupList();
    }

    getUserList = () => {
        axios({
            method: "get",
            url: Constant.API_DOMAIN + "/api/user",
        })
            .then((result) => {
                if (result.data.code === 200) {
                    this.setState({
                        list: result.data.list,
                    });
                } else {
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    console.log(result.data);
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    getGroupList = () => {
        axios({
            method: "get",
            url: Constant.API_DOMAIN + "/api/user/group",
        })
            .then((result) => {
                if (result.data.code === 200) {
                    const groupList = result.data.list;
                    const listColumn = this.state.listColumn;
                    // if (groupList) {
                    //     groupList.forEach((g) => {
                    //         if (g.display) {
                    //             listColumn.push({
                    //                 headerName: g.desc,
                    //                 field: "group_id",
                    //                 width: g.desc.length * 15,
                    //                 minWidth: 100,
                    //                 resizable: true,
                    //                 cellClass: "text-center",
                    //                 cellRenderer: function (params) {
                    //                     const ids = params.value ? params.value.split(",") : [];

                    //                     return `<input type="checkbox" value="${g.id}" ${ids.indexOf("" + g.id) >= 0 ? "checked" : ""} onChange='onChangeGroup(event, ${params.data.id});' ${
                    //                         params.data.is_active ? "" : "disabled"
                    //                     }/>`;
                    //                 },
                    //             });
                    //         }
                    //     });
                    // }
                    this.setState(
                        {
                            groupList: result.data.list,
                            listColumn: listColumn,
                        },
                        () => {
                            if (this.gridApi) {
                                this.gridApi.setColumnDefs(listColumn);
                                this.gridApi.refreshCells({ force: true });
                            }
                        }
                    );
                } else {
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    console.log(result.data);
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
    };

    onFirstDataRendered = (params) => {
        params.api.sizeColumnsToFit();
    };

    onChangeGroup = (e, id) => {
        const isChecked = e.target.checked;
        axios({
            method: isChecked ? "put" : "delete",
            url: `${Constant.API_DOMAIN}/api/user/group/${id}/${e.target.value}`,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    console.log();
                } else {
                    alert("권한 수정 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    console.log(result.data);
                }
            })
            .catch((error) => {
                console.log(error);
                alert("권한 수정 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    openUserInfoModal = (id) => {
        this.setState({
            id: id,
        });
    };

    initPass = (id) => {
        if (window.confirm('패스워드를 "tas1234"로 초기화 하시겠습니까?')) {
            if (id) {
                axios({
                    method: "put",
                    url: `${Constant.API_DOMAIN}/api/user/initPass/${id}`,
                })
                    .then((result) => {
                        if (result.data.code === 200) {
                            alert("패스워드 초기화 되었습니다.");
                            this.getUserList();
                        } else {
                            alert("패스워드 초기화 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                            console.log(result.data);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        alert("패스워드 초기화 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    });
            }
        }
    };

    deleteUser = (id) => {
        if (window.confirm("해당 사용자를 삭제하시겠습니까?")) {
            axios({
                method: "delete",
                url: `${Constant.API_DOMAIN}/api/user/info/${id}`,
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        alert("삭제 되었습니다.");
                        this.getUserList();
                    } else {
                        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                        console.log(result.data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
    };

    render() {
        const { listColumn, list, groupList, id, insertModal } = this.state;
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                    <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                        <div className="row">
                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                                <div className="page-header">
                                    <h2 className="pageheader-title">사용자 관리</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid dashboard-content">
                        <div className="row">
                            <div className="col-xl-4">
                                <button
                                    className="btn btn-sm btn-primary"
                                    onClick={() => {
                                        this.setState({
                                            insertModal: true,
                                        });
                                    }}
                                >
                                    추가
                                </button>
                            </div>
                            <div className="col-xl-8 text-right">
                                <h5>* 비밀번호 초기화 시, <strong>tas1234</strong>로 변경됩니다</h5>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="card pb-0">
                                    <div className="card-body p-0">
                                        <div className="row">
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-alpine" style={{ height: "400px", width: "100%" }}>
                                                <AgGridReactEx
                                                    columnDefs={listColumn}
                                                    rowData={list}
                                                    onGridReady={this.onGridReady}
                                                    rowHeight={40}
                                                    height={700}
                                                    onFirstDataRendered={this.onFirstDataRendered}
                                                ></AgGridReactEx>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <UserInfoModal
                            id={id}
                            onHide={(dataRefresh) => {
                                this.setState(
                                    {
                                        id: 0,
                                    },
                                    () => {
                                        if (dataRefresh) {
                                            this.getUserList();
                                        }
                                    }
                                );
                            }}
                            groupList={groupList}
                        />
                        <UserCreateModal
                            show={insertModal}
                            onHide={(dataRefresh) => {
                                this.setState(
                                    {
                                        insertModal: false,
                                    },
                                    () => {
                                        if (dataRefresh) {
                                            this.getUserList();
                                        }
                                    }
                                );
                            }}
                            groupList={groupList}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const UserInfoModal = ({ id, onHide, groupList }) => {
    const [userInfo, setUserInfo] = useState({
        id: 0,
        name: "",
        is_active: 1,
        pass: "",
        pass_confirm: "",
        group_id: [],
    });
    // crypto.createHash('md5').update(e.target.pass.value).digest('hex');
    useEffect(() => {
        if (id) {
            axios({
                method: "get",
                url: `${Constant.API_DOMAIN}/api/user/info/${id}`,
            })
                .then((result) => {
                    if (result.data.code === 200) {
                        const data = result.data.data;
                        data.group_id = data.group_id ? data.group_id.split(",") : [];
                        data.group_name = data.group_name ? data.group_name.split(",") : [];
                        data.pass = "";
                        data.pass_confirm = "";
                        setUserInfo(data);
                    } else {
                        alert("권한 수정 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                        console.log(result.data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    alert("권한 수정 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                });
        }
        return () => {};
    }, [id]);

    const chageStrHandler = (e) => {
        const { name, value } = e.target;
        const userData = { ...userInfo };

        userData[name] = value;
        setUserInfo(userData);
    };

    const changeStatusHandler = (e) => {
        const { name, value } = e.target;
        const userData = { ...userInfo };

        userData.is_active = value;
        setUserInfo(userData);
    };

    const changeCheckboxHander = (e) => {
        const { name, value, checked } = e.target;
        const userData = { ...userInfo };

        let groups = userData.group_id;

        if (checked) {
            groups.push(value);
        } else {
            groups = groups.filter((g) => g != value);
        }

        userData.group_id = groups;
        setUserInfo(userData);
    };

    const initPass = (id) => {
        if (window.confirm('패스워드를 "1234"로 초기화 하시겠습니까?')) {
            if (id) {
                axios({
                    method: "put",
                    url: `${Constant.API_DOMAIN}/api/user/initPass/${id}`,
                })
                    .then((result) => {
                        if (result.data.code === 200) {
                            alert("패스워드 초기화 되었습니다.");
                        } else {
                            alert("패스워드 초기화 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                            console.log(result.data);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        alert("패스워드 초기화 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    });
            }
        }
    };

    const saveData = () => {
        const { name, is_active, group_id, pass, pass_confirm } = userInfo;
        if (!name.trim()) {
            alert("이름은 빈칸을 입력할 수 없습니다.");
        }

        // if (!pass.trim()) {
        //     alert("패스워드는 빈칸을 입력할 수 없습니다.");
        //     return;
        // }

        if (pass.trim() !== pass_confirm.trim()) {
            alert("패스워드가 동일하지 않습니다.\n입력하신 패스워드를 확인하세요.");
            return;
        }
        axios({
            method: "patch",
            url: `${Constant.API_DOMAIN}/api/user/info/${id}`,
            data: {
                name: name.trim(),
				is_active: is_active,
                group_id: group_id.join(","),
                pass: pass != '' ? crypto.createHash("md5").update(pass.trim()).digest("hex") : null,
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    alert("저장 되었습니다.");
                    onHide(true);
                } else {
                    alert("수정 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    console.log(result.data);
                }
            })
            .catch((error) => {
                console.log(error);
                alert("수정 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    return (
        <Modal
            show={id}
            onHide={() => {
                setUserInfo(null);
                onHide(false);
            }}
            aria-labelledby="example-custom-modal-styling-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">사용자 정보 수정</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {userInfo && (
                    <>
                        <div className="row">
                            <div className="col-xl-6 col-sm-12 mb-2">
                                <label htmlFor="user_id">ID</label>
                                <input type="text" className="form-control p-1" id="user_id" name="user_id" value={userInfo.user_id} disabled={1} />
                            </div>
                            <div className="col-xl-6 col-sm-12 mb-2">
                                <label htmlFor="user_name">이름</label>
                                <input type="text" className="form-control p-1" id="user_name" name="name" value={userInfo.name} onChange={chageStrHandler} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-6 col-sm-12 mb-2">
                                <label htmlFor="pass">패스워드</label>
                                <input type="password" className="form-control p-1" id="pass" name="pass" value={userInfo.pass} onChange={chageStrHandler} />
                            </div>
                            <div className="col-xl-6 col-sm-12 mb-2">
                                <label htmlFor="pass_confirm">패스워드 확인</label>
                                <input type="password" className="form-control p-1" id="pass_confirm" name="pass_confirm" value={userInfo.pass_confirm} onChange={chageStrHandler} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <label htmlFor="is_active" style={{display: "block"}} className="mt-3 mb-0">계정 사용 여부</label>
								<label className="custom-control custom-radio custom-control-inline ">
									<input
										type="radio"
										name="is_active"
										value="1"
										checked={userInfo.is_active == 1}
										className="custom-control-input"
										onChange={changeStatusHandler} 
									/>
									<span className="custom-control-label">사용</span>
								</label>
								<label className="custom-control custom-radio custom-control-inline ">
									<input
										type="radio"
										name="is_active"
										value="0"
										checked={userInfo.is_active == 0}
										className="custom-control-input"
										onChange={changeStatusHandler} 
									/>
									<span className="custom-control-label">미사용</span>
								</label>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-xl-12 col-md-6">
                                <h4>그룹</h4>
                                {groupList.map((g) => {
                                    if (g.display) {
                                        return (
                                            <label htmlFor={`group_${g.id}`} className="custom-control custom-checkbox custom-control-inline">
                                                <input
                                                    id={`group_${g.id}`}
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    name="group"
                                                    checked={userInfo.group_id.indexOf("" + g.id) >= 0}
                                                    value={g.id}
                                                    onChange={changeCheckboxHander}
                                                />
                                                <span className="custom-control-label">{g.desc}</span>
                                            </label>
                                        );
                                    } else {
                                        return <></>;
                                    }
                                })}
                            </div>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" onClick={saveData}>
                    저장
                </button>
                <button className="btn btn-danger" onClick={onHide}>
                    취소
                </button>
            </Modal.Footer>
        </Modal>
    );
};

const UserCreateModal = ({ show, onHide, groupList }) => {
    const [userInfo, setUserInfo] = useState({
        user_id: "",
        name: "",
        pass: "",
        pass_confirm: "",
        group_id: [],
    });
    // ;
    useEffect(() => {
        setUserInfo({
            user_id: "",
            name: "",
            pass: "",
            pass_confirm: "",
            group_id: [],
        });
        return () => {};
    }, [show]);

    const chageStrHandler = (e) => {
        const { name, value } = e.target;
        const userData = { ...userInfo };

        userData[name] = value;
        setUserInfo(userData);
    };

    const changeCheckboxHander = (e) => {
        const { name, value, checked } = e.target;
        const userData = { ...userInfo };

        let groups = userData.group_id;

        if (checked) {
            groups.push(value);
        } else {
            groups = groups.filter((g) => g != value);
        }

        userData.group_id = groups;
        setUserInfo(userData);
    };

    const saveData = () => {
        const { user_id, name, pass, pass_confirm, group_id } = userInfo;

        if (!user_id.trim()) {
            alert("ID는 빈칸을 입력할 수 없습니다.");
            return;
        }

        if (!name.trim()) {
            alert("이름은 빈칸을 입력할 수 없습니다.");
            return;
        }

        if (!pass.trim()) {
            alert("패스워드는 빈칸을 입력할 수 없습니다.");
            return;
        }

        if (pass.trim() !== pass_confirm.trim()) {
            alert("패스워드가 동일하지 않습니다.\n입력하신 패스워드를 확인하세요.");
            return;
        }

        axios({
            method: "post",
            url: `${Constant.API_DOMAIN}/api/user/info`,
            data: {
                user_id: user_id.trim(),
                name: name.trim(),
                pass: crypto.createHash("md5").update(pass.trim()).digest("hex"),
                group_id: group_id.join(","),
            },
        })
            .then((result) => {
                if (result.data.code === 200) {
                    alert("저장 되었습니다.");
                    onHide(true);
                } else {
                    console.log(result.data.msg);
                    alert(result.data.msg);
                }
            })
            .catch((error) => {
                console.log(error);
                alert("저장 중 알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    return (
        <Modal
            show={show}
            onHide={() => {
                setUserInfo(null);
                onHide(false);
            }}
            aria-labelledby="example-custom-modal-styling-title"
        >
            <Modal.Header closeButton>
                <Modal.Title id="example-custom-modal-styling-title">사용자 추가</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {userInfo && (
                    <>
                        <div className="row">
                            <div className="col-xl-6 col-sm-12 mb-2">
                                <label htmlFor="user_id">ID</label>
                                <input type="text" className="form-control p-1" id="user_id" name="user_id" value={userInfo.user_id} onChange={chageStrHandler} />
                            </div>
                            <div className="col-xl-6 col-sm-12 mb-2">
                                <label htmlFor="user_name">이름</label>
                                <input type="text" className="form-control p-1" id="user_name" name="name" value={userInfo.name} onChange={chageStrHandler} />
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-xl-6 col-sm-12 mb-2">
                                <label htmlFor="pass">패스워드</label>
                                <input type="password" className="form-control p-1" id="pass" name="pass" value={userInfo.pass} onChange={chageStrHandler} />
                            </div>
                            <div className="col-xl-6 col-sm-12 mb-2">
                                <label htmlFor="pass_confirm">패스워드 확인</label>
                                <input type="password" className="form-control p-1" id="pass_confirm" name="pass_confirm" value={userInfo.pass_confirm} onChange={chageStrHandler} />
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-xl-12 col-md-6">
                                <h4>그룹</h4>
                                {groupList.map((g) => {
                                    if (g.display) {
                                        return (
                                            <label htmlFor={`group_${g.id}`} className="custom-control custom-checkbox custom-control-inline">
                                                <input
                                                    id={`group_${g.id}`}
                                                    type="checkbox"
                                                    className="custom-control-input"
                                                    name="group"
                                                    checked={userInfo.group_id.indexOf("" + g.id) >= 0}
                                                    value={g.id}
                                                    onChange={changeCheckboxHander}
                                                />
                                                <span className="custom-control-label">{g.desc}</span>
                                            </label>
                                        );
                                    } else {
                                        return <></>;
                                    }
                                })}
                            </div>
                        </div>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" onClick={saveData}>
                    저장
                </button>
                <button className="btn btn-danger" onClick={onHide}>
                    취소
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default Users;
